import { render, staticRenderFns } from "./CombinationQuestion.vue?vue&type=template&id=0daec263&scoped=true"
import script from "./CombinationQuestion.vue?vue&type=script&lang=js"
export * from "./CombinationQuestion.vue?vue&type=script&lang=js"
import style0 from "./CombinationQuestion.vue?vue&type=style&index=0&id=0daec263&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0daec263",
  null
  
)

export default component.exports